module.exports = __webpack_public_path__ + "img/home-vector.44ac9d60.svg";